<template>
    <basic-content-layout id="cancel-subscription-succeeded-page" class="content">
        <section id="how-to-cancel">
            <b-container class="mb-5">
                <h1 class="display-3 mt-5">{{ $t('content.subscription.cancellation-confirmation.title') }}</h1>
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <p>{{ $t('content.subscription.cancellation-confirmation.description') }}</p>
                    </b-col>
                </b-row>
            </b-container>
        </section>
        <section></section>
    </basic-content-layout>
</template>
<script>
import BasicContentLayout from '../../layouts/BasicContentLayout.vue'
import CatalogPageHeader from "../../components/organisms/CatalogPageHeader.vue";
import { BContainer, BRow, BCol} from "bootstrap-vue";
export default {
    components: {
        BasicContentLayout,
        CatalogPageHeader,
        BContainer, BRow, BCol
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.aboutCancelSubscription.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.aboutSubscription.description') }
            ]
        }
    },
    mounted() {
        this.$axios.get('api/v1/subscription/cancel/' + this.$route.params.hash).then(response => {
            console.log(response.data);
        });
    }
}
</script>
